import * as Yup from 'yup';

const validate = Yup.object().shape({
  description: Yup.object().shape({
    Dosage: Yup.string(),
    id: Yup.string(),
    name: Yup.string(),
    unitPrice: Yup.number(),
    uom: Yup.string(),
    vendor: Yup.string(),
  }),
  uomUnit: Yup.string().required('Required'),
  amountPerTime: Yup.number()
    .typeError('This field must be number')
    .required('Required')
    .min(0.1, 'Dosage must be greater than or equal to 0.1'),
  quantity: Yup.number()
    .typeError('This field must be number')
    .required('Required')
    .test('uom-required', 'Missing UOM', function (value) {
      const { uomUnit } = this.parent;
      return !!uomUnit;
    }),
  doseUnitCode: Yup.string().required('Required'),
  frequencyCode: Yup.string().required('Required'),
  note: Yup.string().max(500, 'Note should be less than or equal to 500 characters'),
});

export default validate;
